import React from 'react'

interface IconArrowCircleProps {
  className?: string
  color?: string
}

export const IconArrowCircle: React.FC<IconArrowCircleProps> = ({ className, color }) => {
  return (
    <svg className={className} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="15" fill={color} fillOpacity="0.05" />
      <path
        d="M19.4922 13L15.3166 17.3626L10.9994 13.1576"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}
